import { c as _c } from "react/compiler-runtime";
import { BLOG_PAGE_SIZE } from "@/constants/BlogPageSize";
import { BlogCardSkeleton } from "./BlogCardSkeleton";
export const BlogLoadingSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 pb-6" aria-busy="true">{Array.from({
        length: BLOG_PAGE_SIZE
      }).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(_, i) {
  return <div key={`skel-${i}`} className="animate-in fade-in duration-300"><BlogCardSkeleton /></div>;
}